import React from 'react';
import { Authenticated } from '@refinedev/core';
import { RedirectToLoginPage } from './RedirectToLoginPage';
import { Outlet } from 'react-router-dom';

export default function AuthenticatedRoute() {
  return (
    <Authenticated
      key="protected"
      fallback={<RedirectToLoginPage />}
      v3LegacyAuthProviderCompatible={false}
    >
      <Outlet />
    </Authenticated>
  );
}
